import request from '@/utils/request'

import { ResponseData, ResponseDataList, Search, CURD, SuggestionSearch, ResponseDataArray } from '../schemas'

export const getList = (data: Search): Promise<ResponseDataList> => {
    return request({
        url: '/scenic-area-categories/search',
        method: 'post',
        data,
    })
}

export const doAdd = (data: CURD): Promise<ResponseData> => {
    return request({
        url: '/scenic-area-categories',
        method: 'post',
        data,
    })
}

export const doUpdate = (data: CURD): Promise<ResponseData> => {
    return request({
        url: '/scenic-area-categories',
        method: 'put',
        data,
    })
}

export const doDelete = (data: CURD): Promise<ResponseData> => {
    return request({
        url: `/scenic-area-categories/${String(data.id)}`,
        method: 'delete',
    })
}

export const getTree = (data: CURD): Promise<ResponseDataArray> => {
    return request({
        url: '/scenic-area-categories/tree',
        method: 'post',
        data,
    })
}

export const getDetail = (id: string): Promise<ResponseData> => {
    return request({
        url: `/scenic-area-categories/${id}`,
        method: 'get',
    })
}



export const getSuggestions = (data: SuggestionSearch): Promise<ResponseDataArray> => {
    return request({
        url: '/scenic-area-categories/suggestions',
        method: 'post',
        data
    })
}


